import { getAddress } from "viem"

export const vaults = new Map([
  [
    getAddress("0x0a1eCC5Fe8C9be3C809844fcBe615B46A869b899"),
    {
      name: "Euler Arbitrum USDC",
      description:
        "A conservative USDC vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x37512F45B4ba8808910632323b73783Ca938CD51"),
    {
      name: "Euler Arbitrum USDT0",
      description:
        "A conservative USDT0 vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x78E3E051D32157AACD550fBB78458762d8f7edFF"),
    {
      name: "Euler Arbitrum WETH",
      description:
        "A conservative WETH vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xA8616E4D9f3f0aa01aff1d7c3b66249f8a5f1A58"),
    {
      name: "Euler Arbitrum wstETH",
      description:
        "A conservative wstETH vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x5A8294CE02908B1da68c6c39695c9b0FbaF7675d"),
    {
      name: "Euler Arbitrum weETH",
      description:
        "A conservative weETH vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x889E1c458B2469b70aCcdfb5B59726dC1668896C"),
    {
      name: "Euler Arbitrum WBTC",
      description:
        "A conservative WBTC vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x7eD866D2D66c3149FaFE854C30C68a8BA7ceE8B9"),
    {
      name: "Euler Arbitrum ARB",
      description:
        "A conservative ARB vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x0EE8D628411F446BFbbe08BDeF53E42414C8fBC4"),
    {
      name: "Euler Arbitrum sUSDS",
      description:
        "A conservative sUSDS vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xa7a9B773f139010f284E825a74060648d91dE37a"),
    {
      name: "Euler Arbitrum sUSDC",
      description:
        "A conservative sUSDC vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xE96e07C16661744836a742Ef2090F11e84a86f4F"),
    {
      name: "Euler Arbitrum rsETH",
      description:
        "A conservative rsETH vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xDBD974Eb5360d053ea0c56B4DaCF4A9D3E894Ee2"),
    {
      name: "Euler Arbitrum tETH",
      description:
        "A conservative tETH vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xaA525D3142A5BDD3E55E8e983D3789b88F2FEB8f"),
    {
      name: "Euler Arbitrum ezETH",
      description:
        "A conservative ezETH vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x1Ed564CFC30b385C9C2B184F25602764dD6A16c9"),
    {
      name: "Euler Arbitrum rETH",
      description:
        "A conservative rETH vault collateralized by other vaults in the Euler Arbitrum cluster and escrow vaults.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x05d28A86E057364F6ad1a88944297E58Fc6160b3"),
    {
      name: "Euler Arbitrum Yield USDC",
      description:
        "A USDC vault collateralized by other vaults in the Euler Arbitrum Yield cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xF2cf48e4932835c941cCCd27e450c71138df81Ca"),
    {
      name: "Euler Arbitrum Yield USDT0",
      description:
        "A USDT0 vault collateralized by other vaults in the Euler Arbitrum Yield cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x5059ff3008ffE2b50980330A402ea5c59dA01AD7"),
    {
      name: "Euler Arbitrum Yield USDS",
      description:
        "A USDS vault collateralized by other vaults in the Euler Arbitrum Yield cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x7007415237e9b1c729404A3363293e0a44EAF585"),
    {
      name: "Euler Arbitrum Yield sUSDS",
      description:
        "A sUSDS vault collateralized by other vaults in the Euler Arbitrum Yield cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x8E8FA7c73BeF97205552456A7D41E14cAf57404D"),
    {
      name: "Euler Arbitrum Yield sUSDC",
      description:
        "A sUSDC vault collateralized by other vaults in the Euler Arbitrum Yield cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x815ca5D298d5731a1093BA6E280019E4231465bf"),
    {
      name: "Euler Arbitrum Yield USDe",
      description:
        "A USDe vault collateralized by other vaults in the Euler Arbitrum Yield cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xA94b187D2E767184027316cA2C6F34E80d5bef1f"),
    {
      name: "Euler Arbitrum Yield USR",
      description:
        "A USR vault collateralized by other vaults in the Euler Arbitrum Yield cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x78eDA68722936f4f8BD480DFbEb9f56af6D231de"),
    {
      name: "Euler Arbitrum Yield thBILL",
      description:
        "A thBILL vault collateralized by other vaults in the Euler Arbitrum Yield cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x98BeF5BE3df319D4469B3984c21449d309f8D81E"),
    {
      name: "Euler Arbitrum Yield sUSDe",
      description:
        "A sUSDe vault collateralized by other vaults in the Euler Arbitrum Yield cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xA999f8a38A902f27F278358c4bD20fe1459Ae47C"),
    {
      name: "Euler Arbitrum Yield syrupUSDC",
      description:
        "A syrupUSDC vault collateralized by other vaults in the Euler Arbitrum Yield cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xa5000c60AecafB2f765344e3eb5918B84F386E94"),
    {
      name: "Euler Arbitrum Yield wstUSR",
      description:
        "A wstUSR vault collateralized by other vaults in the Euler Arbitrum Yield cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x46E57D0dE266638C8339689be04B038049Be3812"),
    {
      name: "Euler Arbitrum Yield RLP",
      description:
        "A RLP vault collateralized by other vaults in the Euler Arbitrum Yield cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x6aFB8d3F6D4A34e9cB2f217317f4dc8e05Aa673b"),
    {
      name: "K3 Capital USDai USDC",
      description: "Component of the K3 Capital USDai Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x482C3E2530FAc8FE2c63AE007AD2695C6d685E98"),
    {
      name: "K3 Capital USDai USDT0",
      description: "Component of the K3 Capital USDai Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x7D9790403FA53eF3E3a3389c259D244BDc61B785"),
    {
      name: "K3 Capital USDai USDai",
      description: "Component of the K3 Capital USDai Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0xAABb9cbAC15a3D646dCdc6574bCFCfB989E1fDd8"),
    {
      name: "K3 Capital USDai sUSDai",
      description: "Component of the K3 Capital USDai Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x683B777A393BA94F3c903fba2b14A6b6fF80dbE7"),
    {
      name: "K3 Capital USDai USDe",
      description: "Component of the K3 Capital USDai Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x22038F6FA20AeacBa681030B2fb7c77155901c3F"),
    {
      name: "K3 Capital USDai PT-USDai-20NOV2025",
      description: "Component of the K3 Capital USDai Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x4d375ed67a83eDbC03685141F551DefE25b4917e"),
    {
      name: "K3 Capital USDai PT-sUSDai-20NOV2025",
      description: "Component of the K3 Capital USDai Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0xFe3320fD1baCf38Bf74B84eF0ef7b34562926DDf"),
    {
      name: "K3 Capital AutoUSDai",
      description: "Component of the K3 Capital USDai Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x5F7f81Fb9a3CfBF35633349990BBc5001f365408"),
    {
      name: "K3 Capital PT-USDai-19FEB2026",
      description: "Component of the K3 Capital USDai Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x878e12C1a1bBDF7645E28a8e9c420ccD595204aD"),
    {
      name: "K3 Capital PT-sUSDai-19FEB2026",
      description: "Component of the K3 Capital USDai Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x44C10DA836d2aBe881b77bbB0b3DCE5f85C0C1Cc"),
    {
      name: "Euler Theo USDC",
      description: "Component of the Euler Theo Market",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0xEE074ceB44adA094391B9C71A7Fb8ba6962D492c"),
    {
      name: "Euler Theo USDT",
      description: "Component of the Euler Theo Market",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0x79e1F4a1Cde92568D58EB823f81D9c0C7C384e6b"),
    {
      name: "Euler Theo thBILL",
      description: "Component of the Euler Theo Market",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0x1e001f95599bC024eF5cd5e3CFC4C9bB52c65732"),
    {
      name: "Euler Theo PT-tbBILL-27NOV2025",
      description: "Component of the Euler Theo Market",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0x1DA09605FEfD09312B3004212a7274D7bb1DD891"),
    {
      name: "Euler Theo PT-thBILL-19FEB2026",
      description: "Component of the Euler Theo Market",
      entity: ["euler-dao", "gauntlet"],
    },
  ],
  [
    getAddress("0x124BeC4d119bc4B5d250f0b0114f2087f8EeDB57"),
    {
      name: "AlphaGrowth yUSND Arbitrum Vault",
      description: "A supply-only yUSND vault managed by AlphaGrowth.",
      entity: "alphagrowth",
    },
  ],
  [
    getAddress("0x4aD21eBbB639c21ccd9F1eaF388Cd91D015E02ee"),
    {
      name: "AlphaGrowth USND Arbitrum Vault",
      description:
        "A borrowing-enabled USND vault managed by AlphaGrowth, enabling leveraged strategies with yUSND collateral.",
      entity: "alphagrowth",
    },
  ],
  [
    getAddress("0x8Ca487811a5e7599A5c68F49Ac1fE348371e4c46"),
    {
      name: "AlphaGrowth reUSD Arbitrum Vault",
      description: "A supply-only reUSD vault managed by AlphaGrowth.",
      entity: "alphagrowth",
    },
  ],
  [
    getAddress("0x06b763aA769ad01F6859a56c5a856E47896e6a7F"),
    {
      name: "AlphaGrowth USDC Arbitrum Vault",
      description:
        "A borrowing-enabled USDC vault managed by AlphaGrowth, enabling leveraged strategies with reUSD collateral.",
      entity: "alphagrowth",
    },
  ],
])
